<template>
  <div class="header">
    <div class="title">
      <slot />
    </div>
  </div>
</template>
<script>
// Калькулятор/колокольчик/тикер курсов переехали в GlobalHeaderWidgets.vue
// (рендерится один раз в App.vue, как SideMenu) — раньше жили здесь, но
// PageHeader вставляется заново в шаблон КАЖДОЙ страницы, и при переходе
// между страницами (SPA) пересоздавался с нуля вместе с ними, сбрасывая
// введённые в калькуляторе значения.
export default {
  name: "PageHeader"
};
</script>



// WEBPACK FOOTER //
// src/components/ui/PageHeader.vue